module.exports = __webpack_public_path__ + "static/media/jupiter.e7e2c136.svg";